import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function DuplicateWarning({kind, matches, onCancel, onConfirm, busy = false}) {
  const review = useRef(null), save = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    review.current?.focus();
    return () => { if (previous?.isConnected) previous.focus(); };
  }, []);
  function handleKey(event) {
    if (event.key === "Escape" && !busy) { event.preventDefault(); onCancel(); }
    if (event.key === "Tab") {
      event.preventDefault();
      (document.activeElement === review.current ? save : review).current?.focus();
    }
  }
  return createPortal(<div className="ui-backdrop" style={{position:"fixed",inset:0,display:"flex",alignItems:"center",justifyContent:"center",zIndex:6000}} onKeyDown={handleKey}>
    <section className="ui-modal ui-modal-small" role="alertdialog" aria-modal="true" aria-labelledby="duplicate-warning-title" aria-describedby="duplicate-warning-description">
      <h3 id="duplicate-warning-title">Possible duplicate {kind}</h3>
      <p id="duplicate-warning-description">{kind === "material" ? "A material with the same name already exists." : "These blocks have the same material, supplier, dimensions and quantity."}</p>
      <ul>{matches.map(match => <li key={match.id}>{match.name || match.code || `Block #${match.id}`}</li>)}</ul>
      <p>Review the existing records or save another record anyway.</p>
      <div className="ui-actions ui-form-actions">
        <button ref={review} className="ui-secondary" type="button" onClick={onCancel} disabled={busy}>Review details</button>
        <button ref={save} className="ui-primary" type="button" onClick={onConfirm} disabled={busy}>{busy ? "Saving…" : "Save anyway"}</button>
      </div>
    </section>
  </div>, document.body);
}
